module.exports = __webpack_public_path__ + "img/pop_zhCn.91d22274.png";